import React, { useContext } from 'react';
import { PriceCalculationContext } from '../../PriceCalculationContext';
import clsx from 'clsx';
import { getOrgNameFromOrgId } from '../../utils/getOrgNameFromOrgId';

function SelectAmounts() {
    const {
        productData,
        amountInputErrors,
        amountInputsTouched,
        fixedAmounts,
        organizationData,
        handleAmountInputChange,
        handleAmountInputBlur,
        selectedOrganizationsIds,
        resourcedTexts,
    } = useContext(PriceCalculationContext);
    
    const unitData = productData?.unitData || {};
    const { question, min, max, multiplier, isFixedForOrganizations } = unitData;

    function getFixedAmountForOrgId(orgId) {
        let amount;
        fixedAmounts?.forEach((amountObj) => {
            if (amountObj.organizationId === orgId) {
                amount = amountObj.amount;
            }
        });
        return amount;
    }

    return (
        <div className="select-amount">
            <h4 className="select-amount__heading">{resourcedTexts.amountHeading}</h4>
            {question && <p>{question}</p>}

            <div className="select-amount__row">
                <div className="select-amount__cell select-amount__cell--left" />
                <div className="select-amount__cell select-amount__cell--right">
                    {resourcedTexts.amountLabel}
                </div>
            </div>
            {selectedOrganizationsIds?.map((orgId) => {
                const orgName = getOrgNameFromOrgId(organizationData, orgId);
                const amountId = 'amount__' + orgId;
                const amount = getFixedAmountForOrgId(orgId);

                const isTouched = amountInputsTouched.has(amountId);
                const errorMessage = amountInputErrors.get(amountId);
                const showError = !isFixedForOrganizations && errorMessage && isTouched;

                return (
                    <div
                        className={clsx(
                            'select-amount__row',
                            isFixedForOrganizations && 'select-amount__row--fixed-amount',
                        )}
                        key={amountId}
                    >
                        <div className="select-amount__cell select-amount__cell--left">
                            <label htmlFor={amountId}>{orgName}</label>
                            {showError && <div className="select-amount__error">{errorMessage}</div>}
                        </div>
                        <div className="select-amount__cell select-amount__cell--right">
                            <div className="form-field">
                                {isFixedForOrganizations ? (
                                    <div className="select-amount__fixed-amount">
                                        {amount}&nbsp;
                                        <input
                                            hidden
                                            id={amountId}
                                            name={amountId}
                                            type="number"
                                            value={amount}
                                            disabled
                                        />
                                    </div>
                                ) : (
                                    <input
                                        className={clsx(
                                            'select-amount__input',
                                            showError && 'select-amount__input--error',
                                        )}
                                        id={amountId}
                                        name={amountId}
                                        type="number"
                                        min={min}
                                        max={max > 0 ? max : undefined}
                                        step={multiplier}
                                        onChange={handleAmountInputChange}
                                        onBlur={handleAmountInputBlur}
                                        required
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export { SelectAmounts };
